import { I08CALCVOLEXP_State } from '@batical/types/src'

const I08CALCVOLEXP: I08CALCVOLEXP_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_volEauRet: 0.0,
  in_temperature: 60.0,
  pickerSelected: '0',
  in_hauteurInstallation: 0.0,
  in_hauteurVase: 0.0,
  in_pressionMin: 0.0,
  in_pressionSoupape: 0.0,
  in_pressionRefoulement: 0.0,
  in_volumVaseChoisit: 0.0,
  res_pressionGonflage: 0.0,
  res_pressionMax: 0.0,
  res_pressionFinal: 0.0,
  res_facteurPression: 0.0,
  res_volumeVaseExpansion: 0.0,
  res_pressionInitialVase: 0.0,
  res_volumeReserve2: 0.0,
  mode: 'none',
  calcul_code: 'I08CALCVOLEXP'
}

export default I08CALCVOLEXP
